export default __webpack_public_path__ + "c857a9396e30d5f88c274320d03d8de6.png";